import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.b3{border:none;}.ssr-plugin'
import '.b4{background-color:transparent;}.ssr-plugin'
import '.fv{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.d6{position:sticky;}.ssr-plugin'
import '.fw{top:4rem;}.ssr-plugin'
import '.fx{z-index:7;}.ssr-plugin'
import '.ag{background-color:var(--shades-white);}.ssr-plugin'
import '.fy{padding-bottom:1rem;}.ssr-plugin'
import '.a2{margin-bottom:1rem;}.ssr-plugin'
import '.fz{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a7{position:fixed;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.g0{bottom:0px;}.ssr-plugin'
import '.em{z-index:9999;}.ssr-plugin'
import '.g1{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dz{justify-content:flex-end;}.ssr-plugin'
import '.bv{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bn bp u bk b3 b4 fv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ad"
    >
      <div className="d6 fw fx ag fy a2 fz a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a7 co bi bj g0 em ag g1 a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bp a dz fz"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bv at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
